module.exports = __webpack_public_path__ + "img/QRcode.410ac6f2.png";